import React from "react"
import styled from "styled-components"
import { motion } from "framer-motion"
import { breakpoints } from "../../../theme"
import { useTranslation } from "react-i18next"

const Layer = styled(motion.div)`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9;
`

const InnerLayer = styled(motion.div)`
  overflow-y: auto;
  flex-direction: column;
  background-color: #fff;
  width: calc(100% - 72px);
  margin-left: auto;
  max-width: 465px;
  padding: 0 0 0 30px;

  @media (min-width: ${breakpoints.small}px) {
    padding: 0 0 0 65px;
  }

  @media (min-width: ${breakpoints.medium}px) {
    padding: 0 0 0 95px;
  }
`

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 18px 23px 0 0;
  margin: 20px 0px 25px 0px;

  @media (min-width: ${breakpoints.medium}px) {
    padding: 18px 23px 0 0;
    margin: 85px 0px 25px 0px;
  }
`

const Close = styled.button`
  cursor: pointer;
  border: 0;
  padding: 0;
  background: none;
  display: flex;
  align-items: flex-start;
  font-weight: 300;
  font-size: 16px;
  letter-spacing: 0.003em;
  color: #000;

  > :nth-child(1) {
    margin-right: 15px;
  }
`

const variants = {
  open: { opacity: 1, display: "flex", justifyContent: "flex-end" },
  closed: { opacity: 0, transitionEnd: { display: "none" } },
}

const innerVariants = {
  open: { opacity: 1, x: 0, display: "flex" },
  closed: { opacity: 0, x: "40px", transitionEnd: { display: "none" } },
}

const LayerMenu = ({ children, show, setShow }) => {
  const { t } = useTranslation()
  const layerRef = React.useRef(null)

  const closeOnOutsideClick = (e, ref) => {
    if (e.target === ref.current) {
      setShow(false)
    }
  }

  React.useEffect(() => {
    const handleEsc = event => {
      if (event.keyCode === 27) {
        setShow(false)
      }
    }
    window.addEventListener("keydown", handleEsc)

    return () => {
      window.removeEventListener("keydown", handleEsc)
    }
  }, [setShow])

  return (
    <Layer
      animate={show ? "open" : "closed"}
      variants={variants}
      transition={{ duration: 0.4 }}
      initial={false}
      ref={layerRef}
      onClick={e => closeOnOutsideClick(e, layerRef)}
    >
      <InnerLayer
        animate={show ? "open" : "closed"}
        variants={innerVariants}
        transition={{ duration: 0.6 }}
        initial={false}
      >
        <Header>
          <Close
            onClick={() => {
              setShow(false)
            }}
          >
            <svg
              aria-label={t("menu.close")}
              viewBox="0 0 24 24"
              height="20"
              width="20"
            >
              <path
                fill="none"
                stroke="#000"
                strokeWidth="2"
                d="m3 3 18 18M3 21 21 3"
              />
            </svg>
            {t("menu.close")}
          </Close>
        </Header>
        <nav>{children}</nav>
      </InnerLayer>
    </Layer>
  )
}

export default LayerMenu
